export const MuiCard = {};
export const MuiCardContent = {
    styleOverrides: {
        root: {
            padding: 24,
        },
    },
};
export const MuiCardActions = {
    styleOverrides: {
        root: {
            padding: '0 24px 24px 24px',
        },
    },
};
